module.exports = __webpack_public_path__ + "img/sunset.5de07100.svg";